import WarningIcon from "@mui/icons-material/Warning";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { capitalize, keys } from "lodash";

import { error, misc } from "app/themes/colors";
import { ErrorsState } from "hooks/use-errors.hook";

type ErrorStateSnackbarContentProps = {
  title?: string;
  errors: ErrorsState;
  showAsWarning?: boolean;
};

export default function ErrorStateSnackbarContent({
  title,
  errors,
  showAsWarning
}: ErrorStateSnackbarContentProps) {
  const { fieldErrors, nonFieldErrors } = errors;
  const messages = new Set<string>();

  keys(fieldErrors).forEach((fieldName) => {
    fieldErrors[fieldName].forEach((error) => {
      messages.add(
        `${capitalize(fieldName).replace("_", " ")}: ${error.message}`
      );
    });
  });

  nonFieldErrors.forEach((error) => {
    messages.add(error.message);
  });

  return (
    <Stack spacing={1}>
      {Boolean(title) && (
        <Stack direction="row" alignItems="center" spacing={1}>
          {showAsWarning && (
            <WarningIcon sx={{ fontSize: "22px", color: misc.warningText }} />
          )}
          <Typography
            fontWeight={700}
            fontSize="16px"
            color={showAsWarning ? misc.warningText : error[700]}
            sx={{ pb: 0.3 }}
          >
            {title}
          </Typography>
        </Stack>
      )}
      <Stack direction="column" spacing={1}>
        {!Boolean(title) && messages.size === 1 && showAsWarning && (
          <WarningIcon sx={{ fontSize: "22px", color: misc.warningText }} />
        )}
        {[...messages].map((message) => (
          <Typography
            key={message}
            fontWeight={700}
            fontSize="16px"
            color={showAsWarning ? misc.warningText : error[700]}
          >
            {message}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
}
